import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loaderActions } from '../../../_actions/loader.actions';
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../components/commonClass/Session';
import { formatDateRequire, formatDatewithtime } from '../../../components/commonClass/CommonValidation';
import Select from 'react-select';
import DataTable from 'react-data-table-component';
import { CustomModal } from '../../../customControl/CustomModal';
import TAAdvanceFilter from './partial/TAAdvanceFilter';
import ExportReport from '../../../customControl/ExportReport';

const TAQueryLog = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((store: any) => store.userstatus.tba);
    const menuItem = useSelector((store: any) => store.menuitems.menu);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);
    const [modalopen, setModalOpen] = useState(false)
    const [modalopenfilter, setModalOpenFilter] = useState(false)
    const [exportopen, setExportOpen] = useState(false)

    const [status, setStatus] = useState('All Queries')

    const [dropdownList, setDropDownList] = useState<any>([])
    const [queryList, setQueryList] = useState([])
    const [queryFilterList, setQueryFilterList] = useState([])
    const [querypopup, setQueryPopUp] = useState<any>([])
    const clonePath = 'https://static-ethics.sgp1.digitaloceanspaces.com/etm/';
    const [searchValue, setSearchValue] = useState('')
    const [searchId, setSearchId] = useState(100)

    useEffect(() => {
        //check for rights
        let pagelink = user?.find((x: any) => {
            if (x?.PageLink === window?.location?.pathname)
                return x.MenuId
        });
        let mid = user?.find((x: any) => x?.MenuId === pagelink?.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter((x: any) => x.MenuId === pagelink?.MenuId)?.map((obj: any) => {
            setUserAdd(obj?.URightAdd);
            setUserEdit(obj?.URightEdit);
            setUserExport(obj?.URightExport);
        });
    }, [user])

    const opendetails = (Query: any) => {
        setQueryPopUp(Query)
        setModalOpen(true);
    }


    const gettravelagentqueryoptions = async () => {
        dispatch(loaderActions.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const list = await getAllData('/midoffice/v1/gettravelagentqueryoptions')
            if (list?.status) {
                const rawCityList = list?.data?.cityList || [];
                const cityList = rawCityList?.map((obj: any) => ({
                    label: obj?.City,
                    value: obj?.LocationId,
                }));
                const rawPackageList = list?.data?.packageList || [];
                const packageList = rawPackageList?.map((obj: any) => ({
                    label: obj?.PackageName,
                    value: obj?.PackageId,
                    code: obj?.PackageCode,
                }));
                const rawtravelCategoryList = list?.data?.travelCategoryList || [];
                const travelCategoryList = rawtravelCategoryList?.map((obj: any) => ({
                    label: obj?.TravelCategoryName,
                    value: obj?.TravelCategoryId
                }));
                const rawassigneeList = list?.data?.assigneeList || [];
                const assigneeList = rawassigneeList?.map((obj: any) => ({
                    label: obj?.FullName,
                    value: obj?.UserMasterID,
                    ImagePath: obj?.ImagePath,
                }));
                setDropDownList({ cityList, packageList, assigneeList, travelCategoryList });
            }
            else {
                setDropDownList([]);
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            dispatch(loaderActions.end());
        }
        dispatch(loaderActions.end());
    }

    const gettravelagentquerylist = async () => {
        dispatch(loaderActions.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const res = await getAllData('/midoffice/v1/gettravelagentquerylist')
            if (res?.status) {
                const List = res?.data;
                setQueryList(List);
                setQueryFilterList(List);
            }
            else {
                setQueryList([]);
                setQueryFilterList([]);
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            dispatch(loaderActions.end());
        }

        dispatch(loaderActions.end());
    }

    const modlabody = () => {
        return (
            <div className="mt-2">
                <div className='modal_body_subheader py-2 mt-2'>
                    <h5 className='mb-0 text-center'>Customer Detail</h5>
                </div>
                <div className='modal_body_subbody mt-2 p-2'>
                    <div className='row'>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-6'>
                                    <label className="form-label mb-1">First Name</label>
                                </div>
                                <div className='col-6'>
                                    <input type="text" className="form-control mb-1" defaultValue={querypopup?.FirstName ? querypopup?.FirstName : '-'} disabled placeholder="First Name" />
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-6'>
                                    <label className="form-label mb-1">Last Name</label>
                                </div>
                                <div className='col-6'>
                                    <input type="text" className="form-control mb-1" defaultValue={querypopup?.LastName ? querypopup?.LastName : '-'} disabled placeholder="Last Name" />
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-6'>
                                    <label className="form-label mb-1">Phone No.</label>
                                </div>
                                <div className='col-6'>
                                    <input type="text" className="form-control mb-1" defaultValue={querypopup?.MobileNo ? querypopup?.MobileNo : '-'} disabled placeholder="Mobile Number" />
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-6'>
                                    <label className="form-label mb-1">Email Id</label>
                                </div>
                                <div className='col-6'>
                                    <input type="text" className="form-control mb-1" defaultValue={querypopup?.EmailId ? querypopup?.EmailId : '-'} disabled placeholder="Email Id" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='modal_body_subheader py-2 mt-2'>
                    <h5 className='mb-0 text-center'>Trip Detail</h5>
                </div>
                <div className='modal_body_subbody mt-2 p-2'>
                    <div className='row'>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-6'>
                                    <label className="form-label mb-1">Origin City</label>
                                </div>
                                <div className='col-6'>
                                    <input type="text" className="form-control mb-1" defaultValue={querypopup?.OriginCityName ? querypopup?.OriginCityName : '-'} readOnly placeholder="Origin City" />
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-6'>
                                    <label className="form-label mb-1">No. Of traveler</label>
                                </div>
                                <div className='col-6'>
                                    <input type="text" className="form-control mb-1" defaultValue={querypopup?.NoOfTraveller ? querypopup?.NoOfTraveller : '-'} readOnly placeholder="No. Of traveler" />
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-6'>
                                    <label className="form-label mb-1">Travel Date</label>
                                </div>
                                <div className='col-6'>
                                    <input type="text" className="form-control mb-1" readOnly defaultValue={querypopup?.TravelDate ? formatDateRequire(querypopup?.TravelDate ?? '-') ?? '-' : '-'} placeholder="Travel Date" />
                                </div>
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-6'>
                                    <label className="form-label mb-1">Destination</label>
                                </div>
                                <div className='col-6'>
                                    <input type="text" className="form-control mb-1" defaultValue={querypopup?.Destination ? querypopup?.Destination : '-'} readOnly placeholder="Destination" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='modal_body_subheader py-2 mt-2'>
                    <h5 className='mb-0 text-center'>Query Description</h5>
                </div>
                <div className='modal_body_subbody mt-2 p-2'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='row'>
                                <div className='col-3'>
                                    <label className="form-label mb-1">Query Description</label>
                                </div>
                                <div className='col-9'>
                                    <textarea rows={3} className="form-control mb-1" defaultValue={querypopup?.QueryDetails ? querypopup?.QueryDetails : '-'} readOnly placeholder="Query Description" ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const hendleStatus = (id: any, name: any) => {
        setStatus(name);
        if (id === 0) {
            setQueryList(queryFilterList)
        }
        else {
            setQueryList(queryFilterList?.filter((el: any) => el.StatusId === id))
        }
    }

    const hendleAssignee = async (e: any, TAQueryAssignmentId: any, QueryId: any, AssignedTo: any, StatusId: any, isAssign: any) => {
        e.stopPropagation();
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            if (TAQueryAssignmentId === null) {
                let user: any = GetLocalStorage();
                const form = {
                    TAQueryAssignmentId: TAQueryAssignmentId ? TAQueryAssignmentId : 0,
                    TravelAgentQueryId: QueryId,
                    AssignedTo: AssignedTo,
                    StatusId: StatusId,
                    UserId: user?.userMasterID
                }
                const RpsData = await postUsersData("/midoffice/v1/inserttaqueryassignment", form);
                if (RpsData?.status) {
                    gettravelagentquerylist();
                    const dropdown: any = document?.querySelectorAll('.queries_table .dropdownAssignee');
                    Array.from(dropdown).forEach((el: any, index: number) => {
                        if (el?.classList?.contains('show')) {
                            el?.classList?.remove('show');
                            document?.getElementById(`assigneebox${index}`)?.classList?.remove('show');
                        }
                    });
                }
            }
            if (isAssign) {
                let user: any = GetLocalStorage();
                const form = {
                    TAQueryAssignmentId: TAQueryAssignmentId ? TAQueryAssignmentId : 0,
                    TravelAgentQueryId: QueryId,
                    AssignedTo: AssignedTo,
                    StatusId: StatusId,
                    UserId: user?.userMasterID
                }
                const RpsData = await postUsersData("/midoffice/v1/inserttaqueryassignment", form);
                if (RpsData?.status) {
                    gettravelagentquerylist()
                }
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            dispatch(loaderActions.end());
        }
    }

    useEffect(() => {
        gettravelagentqueryoptions();
        gettravelagentquerylist();
    }, [])


    const hendlenavigate = () => {
        navigate("/ta-querycreate", { state: { viewtype: 'Add', dropdownList: dropdownList, menuTitle: menuItem?.pageTitle } })
    }
    const hendledropdownclick = (e: any, dropdownindex: any) => {
        e.stopPropagation();
        const dropdown: any = document?.querySelectorAll('.queries_table .dropdownAssignee');
        Array.from(dropdown).forEach((el: any, index: number) => {
            if (index !== dropdownindex && el?.classList?.contains('show')) {
                el?.classList?.remove('show');
                document?.getElementById(`assigneebox${index}`)?.classList?.remove('show');
            }
        });
    }


    //#region serach

    const serachoption = [
        {
            label: 'Query Id',
            value: 1
        },
        {
            label: 'Query Related',
            value: 2
        },
        {
            label: 'Query Source',
            value: 3
        },
        {
            label: 'Query Capture Time & Date',
            value: 4
        },
        {
            label: 'Query Assign Time & Date',
            value: 5
        },
        {
            label: 'Spent Time',
            value: 6
        },
        {
            label: 'Assignee',
            value: 7
        },
        {
            label: 'Status',
            value: 8
        },
        {
            label: 'All',
            value: 100
        },

    ];

    const matchesSearchValueAll = (issec: any, fields: any, val: any) => {
        let search = val
        return fields.some((data: any) => {
            if (data === 'CaptureDateTime' || data === 'AssignDateTime') {
                return (formatDatewithtime(issec[data]))?.toString()?.toLowerCase()?.includes(search?.toLowerCase())
            }
            else {
                return (issec[data])?.toString()?.toLowerCase()?.includes(search?.toLowerCase())
            }
        })
    };

    const handleSearch = (val: any, id: any) => {
        var filterdata: any;
        if (id === 1) {
            filterdata = queryFilterList?.filter((issec: any) => issec?.QueryNo?.toString()?.toLowerCase()?.includes(val?.toLowerCase()));
        }
        if (id === 2) {
            filterdata = queryFilterList?.filter((issec: any) => issec?.PackageName?.toString()?.toLowerCase()?.includes(val?.toLowerCase()));
        }
        if (id === 3) {
            filterdata = queryFilterList?.filter((issec: any) => issec?.QuerySourceName?.toString()?.toLowerCase()?.includes(val?.toLowerCase()));
        }
        if (id === 4) {
            filterdata = queryFilterList?.filter((issec: any) => formatDatewithtime(issec?.CaptureDateTime)?.toString()?.toLowerCase()?.includes(val?.toLowerCase()));
        }
        if (id === 5) {
            filterdata = queryFilterList?.filter((issec: any) => formatDatewithtime(issec?.AssignDateTime)?.toString()?.toLowerCase()?.includes(val?.toLowerCase()));
        }
        if (id === 6) {
            filterdata = queryFilterList?.filter((issec: any) => issec?.SpentTime?.toString()?.toLowerCase()?.includes(val?.toLowerCase()));
        }
        if (id === 7) {
            filterdata = queryFilterList?.filter((issec: any) => issec?.AssigneeName?.toString()?.toLowerCase()?.includes(val?.toLowerCase()));
        }
        if (id === 8) {
            filterdata = queryFilterList?.filter((issec: any) => issec?.StatusName?.toString()?.toLowerCase()?.includes(val?.toLowerCase()));
        }
        if (id === 100) {
            filterdata = queryFilterList?.filter((issec: any) => {
                let keys = [
                    "QueryNo",
                    "PackageName",
                    "QuerySourceName",
                    "CaptureDateTime",
                    "AssignDateTime",
                    "SpentTime",
                    "AssigneeName",
                    "StatusName"
                ]
                return matchesSearchValueAll(issec, keys, val) && issec
            });
        }
        setQueryList(filterdata)
    }

    const hendleSearchoption = (val: any) => {
        setSearchId(val)
        if (searchValue !== '') {
            handleSearch(searchValue, val)
        }
    }


    const onChangesearch = (val: any) => {
        if (val !== '') {
            setSearchValue(val)
            handleSearch(val, searchId)
        }
        else {
            setSearchValue('')
            setQueryList(queryFilterList)
        }
    }
    //#endregion search


    const columns: any = [
        {
            name: <i className='fa-solid fa-arrow-up-short-wide'></i>,
            customName: 'Query ID',
            key: 'QueryNo',
            sortable: true,
            minWidth: "125px",
            maxWidth: "130px",
            float: "left",
            format: (user: any) => <>
                <div onClick={() => opendetails(user)}><small>Query ID</small></div>
                <div className='col_height' onClick={() => opendetails(user)}><span>{user?.QueryNo}</span></div>
            </>,
            selector: (user: any) => (user?.QueryNo),
        },
        {
            name: <i className='fa-solid fa-arrow-up-short-wide'></i>,
            customName: 'Query Related',
            key: 'PackageName',
            sortable: true,
            minWidth: "100px",
            float: "left",
            format: (user: any) => <>
                <div onClick={() => opendetails(user)}><small>Query Related</small></div>
                <div className='col_height' onClick={() => opendetails(user)}><span>{user?.PackageName}</span></div>
            </>,
            selector: (user: any) => (user?.PackageName),
        },
        {
            name: <i className='fa-solid fa-arrow-up-short-wide'></i>,
            customName: 'Query Source',
            key: 'QuerySourceName',
            sortable: true,
            float: "left",
            minWidth: "170px",
            maxWidth: "175px",
            format: (user: any) => <>
                <div onClick={() => opendetails(user)}><small>Query Source</small></div>
                <div className='col_height' onClick={() => opendetails(user)}><span>{user?.QuerySourceName}</span></div>
            </>,
            selector: (user: any) => (user?.QuerySourceName),
        },
        {
            name: <i className='fa-solid fa-arrow-up-short-wide'></i>,
            customName: 'Query Capture Time & Date',
            key: 'CaptureDateTime',
            sortable: true,
            float: "left",
            minWidth: "190px",
            maxWidth: "195px",
            format: (user: any) => <>
                <div onClick={() => opendetails(user)}><small>Query Capture Time & Date</small></div>
                {user?.CaptureDateTime ? <div className='col_height' onClick={() => opendetails(user)}><span>{formatDatewithtime(user?.CaptureDateTime)}</span></div> :
                    <div className='col_height' onClick={() => opendetails(user)}>-</div>}
            </>,
            selector: (user: any) => new Date(user?.CaptureDateTime),
        },
        {
            name: <i className='fa-solid fa-arrow-up-short-wide'></i>,
            customName: 'Assign Time & Date',
            key: 'AssignDateTime',
            sortable: true,
            float: "left",
            minWidth: "190px",
            maxWidth: "195px",
            format: (user: any) => <>
                <div onClick={() => opendetails(user)}><small>Assign Time & Date</small></div>
                {user?.AssignDateTime ? <div className='col_height' onClick={() => opendetails(user)}><span>{formatDatewithtime(user?.AssignDateTime)}</span></div> :
                    <div className='col_height' onClick={() => opendetails(user)}>-</div>}
            </>,
            selector: (user: any) => new Date(user?.AssignDateTime),
        },
        {
            name: <i className='fa-solid fa-arrow-up-short-wide'></i>,
            customName: 'Spent Time',
            key: 'SpentTime',
            sortable: true,
            float: "left",
            minWidth: "95px",
            maxWidth: "100px",
            format: (user: any) => <>
                <div onClick={() => opendetails(user)}><small>Spent Time</small></div>
                <div className='col_height' onClick={() => opendetails(user)}><span>{user?.SpentTime ? user?.SpentTime : '-'}</span></div>
            </>,
            selector: (user: any) => (user?.SpentTime ? Number(user?.SpentTime?.split(":")[0]) * 60 + Number(user?.SpentTime?.split(":")[1]) : 0),
        },
        {
            name: <i className='fa-solid fa-arrow-up-short-wide'></i>,
            customName: 'Priority',
            key: 'PriorityName',
            sortable: true,
            float: "left",
            minWidth: "105px",
            maxWidth: "110px",
            format: (user: any) => <>
                <div onClick={() => opendetails(user)}><small>Priority</small></div>
                {user?.PriorityName === "Low" &&
                    <div onClick={() => opendetails(user)} className='priority_low col_height'>
                        <span className='me-2'><i className="fa-solid fa-arrow-up"></i></span>
                        <span>Low</span>
                    </div>
                }
                {user?.PriorityName === "Medium" &&
                    <div onClick={() => opendetails(user)} className='priority_medium col_height'>
                        <span className='me-2'><i className="fa-solid fa-arrow-up"></i></span>
                        <span>Medium</span>
                    </div>
                }
                {user?.PriorityName === "High Priority" &&
                    <div onClick={() => opendetails(user)} className='priority_high col_height'>
                        <span className='me-2'><i className="fa-solid fa-arrow-up"></i></span>
                        <span>High</span>
                    </div>}
            </>,
            selector: (user: any) => (user?.StatusId),
        },
        {
            name: <i className='fa-solid fa-arrow-up-short-wide'></i>,
            customName: 'Assignee',
            key: 'AssigneeName',
            sortable: true,
            float: "left",
            minWidth: "115px",
            maxWidth: "110px",
            format: (user: any, index: any) => <>
                <div key={index}>
                    <div className="dropdown">
                        <button disabled={!useredit} onClick={(e: any) => hendledropdownclick(e, index)} className="btn dropdown-toggle align-items-center d-flex px-1 py-0 mx-auto dropdownAssignee" type="button" id={`dropdownAssignee${index}`} data-bs-toggle="dropdown" aria-expanded="false">
                            <small>Assignee</small>&nbsp;&nbsp;<i className="fa-solid fa-angle-down"></i>
                        </button>
                        <ul id={`assigneebox${index}`} className="dropdown-menu dropdownAssignee_menu" aria-labelledby={`dropdownAssignee${index}`}>
                            {dropdownList?.assigneeList?.map((el: any, index: any) => (
                                <li key={index} className='mx-1 mb-1'>
                                    <button className={`dropdown-item assign_active ${el?.value === user?.AssignedTo ? 'active' : ''} `} onClick={(e: any) => hendleAssignee(e, user?.TAQueryAssignmentId, user?.QueryId, el?.value, user?.StatusId, false)}>
                                        <span className='float-start'>{el?.label}</span>
                                        <img
                                            className='assignee_img ms-2 float-end'
                                            src={clonePath + el?.ImagePath}
                                            loading='lazy'
                                            onError={(e: any) => e.target.src = require("../../../assets/img/no-image.png")}
                                            alt='img' />
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                {dropdownList?.assigneeList?.find((obj: any) => obj?.value === user?.AssignedTo) ?
                    <div onClick={() => opendetails(user)}>
                        <img className='assignee_img'
                            src={clonePath + dropdownList?.assigneeList?.find((obj: any) => obj?.value === user?.AssignedTo)?.ImagePath}
                            loading='lazy'
                            onError={(e: any) => e.target.src = require("../../../assets/img/no-image.png")}
                            alt='img' />
                    </div>
                    : <div className='col_height' onClick={() => opendetails(user)}>-</div>}
            </>,
            selector: (user: any) => (user?.AssigneeName),
        },
        {
            name: <i className='fa-solid fa-arrow-up-short-wide'></i>,
            customName: 'Status',
            key: 'StatusName',
            sortable: true,
            float: "left",
            minWidth: "140px",
            maxWidth: "150px",
            format: (user: any) => <>
                {user?.StatusId === 1 &&
                    <div className='my-2'><button disabled={!useredit || (user?.AssignedTo ? false : true)} onClick={(e: any) => hendleAssignee(e, user?.TAQueryAssignmentId, user?.QueryId, user?.AssignedTo, 2, true)} type="button" className="btn btn_todo" id="btnAdd">To Do</button></div>
                }
                {user?.StatusId === 2 &&
                    <div className='my-2'><button disabled={!useredit || (user?.AssignedTo ? false : true)} onClick={(e: any) => hendleAssignee(e, user?.TAQueryAssignmentId, user?.QueryId, user?.AssignedTo, 3, true)} type="button" className="btn btn_inprogress" id="btnAdd">In Progress</button></div>
                }
                {user?.StatusId === 3 &&
                    <div className='my-2'><button disabled type="button" className="btn btn_done" id="btnAdd">Done</button></div>
                }
            </>,
            selector: (user: any) => (user?.StatusId),
        },
    ];

    return (
        <>
            <div className="mx-2 mt-0 mb-3 heading_color">
                <h2 className='fw-bold'>{menuItem?.[0]?.pageTitle}</h2>
            </div>
            <div className="m-2 heading_color">
                <div className='row'>
                    <div className='col-6'>
                        <h4>TA&nbsp;{menuItem?.[2]?.pageTitle}</h4>
                    </div>
                    <div className='col-6 text-end'>
                        <button type="button" className="btn btn-primary" disabled={!useradd} onClick={hendlenavigate} id="btnAdd">+ Add Query</button>
                    </div>
                </div>
            </div>
            <div className="m-2">
                <div className='advance_filter p-1'>
                    <div className='row align-items-center'>
                        <div className='col-6'>
                            <button type="button" onClick={() => setModalOpenFilter(true)} className="btn bg-white mx-2 p-1" id="btnAdd"><img src={require('../../../assets/img/filter.png')} width='30px' alt='img' /></button>
                        </div>
                        <div className='col-6'>
                            <div className='row align-items-center'>
                                <div className='col-6'>
                                    <h6 className='mb-0'>{status}</h6>
                                </div>
                                <div className='col-6 text-end'>
                                    <div className="dropdown">
                                        <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i className="fa-solid fa-angle-down"></i>
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            <li className='mx-1 mb-1'><button className={`dropdown-item assign_active ${status === 'All Queries' ? 'active' : ''}`} onClick={(e: any) => hendleStatus(0, 'All Queries')}>All Queries</button></li>
                                            <li className='mx-1 mb-1'><button className={`dropdown-item assign_active ${status === 'To-Do' ? 'active' : ''}`} onClick={(e: any) => hendleStatus(1, 'To-Do')}>To-Do</button></li>
                                            <li className='mx-1 mb-1'><button className={`dropdown-item assign_active ${status === 'In Progress' ? 'active' : ''}`} onClick={(e: any) => hendleStatus(2, 'In Progress')}>In Progress</button></li>
                                            <li className='mx-1'><button className={`dropdown-item assign_active ${status === 'Done' ? 'active' : ''}`} onClick={(e: any) => hendleStatus(3, 'Done')}>Done</button></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="m-2">
                <div className='row'>
                    <div className='col-12 col-md-6'>
                        <div className='row'>
                            <div className='col-8'>
                                <input type="text" id="SearchValue" className="form-control"
                                    name="SearchValue"
                                    value={searchValue}
                                    onChange={(e: any) => onChangesearch(e.target?.value)}
                                    placeholder="Enter Keywords"
                                />
                            </div>
                            <div className='col-4'>
                                <Select
                                    id='genderid'
                                    className="dropdown select_dropdown custom_class"
                                    options={serachoption}
                                    value={serachoption?.filter(function (serachoption: any) {
                                        return serachoption.value === searchId;
                                    })}
                                    isSearchable
                                    onChange={(e: any) => hendleSearchoption(e?.value)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="m-2">
                <div className='countbar_section py-2 px-3'>
                    <div className='d-flex align-items-center'>
                        <span>Total Queries</span>&nbsp;:&nbsp;<h6 className='mb-0 me-3 fw-bold'>{queryFilterList?.length}</h6>
                        <span>Open</span>&nbsp;:&nbsp;<h6 className='mb-0 me-3 fw-bold open_color'>{queryFilterList?.filter((obj: any) => obj?.StatusId === 1)?.length}</h6>
                        <span>In Progress</span>&nbsp;:&nbsp;<h6 className='mb-0 me-3 fw-bold progress_color'>{queryFilterList?.filter((obj: any) => obj?.StatusId === 2)?.length}</h6>
                        <span>Done</span>&nbsp;:&nbsp;<h6 className='mb-0 me-3 fw-bold done_color'>{queryFilterList?.filter((obj: any) => obj?.StatusId === 3)?.length}</h6>
                    </div>
                </div>
            </div>
            <div className="m-2">
                <div className="col-lg-12">
                    <div className="row form_border table_color py-3">
                        <div className={`col-lg-12 mb-1 table-scrollable queries_table`}>
                            {queryList &&
                                <DataTable
                                    columns={columns}
                                    data={queryList}
                                    highlightOnHover
                                    pagination
                                    paginationPerPage={5}
                                    paginationRowsPerPageOptions={[5, 10, 15, 20, 50, 100]}
                                    responsive
                                    onRowClicked={opendetails}
                                />
                            }
                        </div>
                    </div>
                </div>
                <div className="col-lg-12 mt-2">
                    <button type='button'
                        disabled={!userexport}
                        className='border-0 p-0 bg-transparent me-1 set_disableclr'>
                        <i className="fa fa-file-excel-o" aria-hidden="true" style={{ fontSize: "28px", color: "green" }}
                            onClick={() => setExportOpen(true)}>
                        </i>
                    </button>
                </div>
            </div >

            <CustomModal
                show={modalopen}
                size='xl'
                onHide={() => setModalOpen(false)}
                modaltitle='Query Details'
                modalbody={modlabody}
                modalfooter=''
            />
            <TAAdvanceFilter modalopenfilter={modalopenfilter} setModalOpenFilter={setModalOpenFilter} setQueryList={setQueryList} queryFilterList={queryFilterList} dropdownList={dropdownList} />
            <ExportReport setExportOpen={setExportOpen} exportopen={exportopen} filtercolumns={columns} exportList={queryList} excelSheetName={"TAQueryLog"} excelFileName={"TAQueryLog"} />
        </>
    )
}

export default TAQueryLog